document.addEventListener('DOMContentLoaded' , () =>{
    // member - join - law_agreement_page
    if(document.querySelector('.join-select-page')){
        let allCheck = document.querySelector('#all_chk');
        let ipCheckList = document.querySelectorAll('.ip_all[name=agree_chk]');
        // let ipChoiceCk = document.querySelectorAll('.ip_choice');
        
        allCheck.addEventListener('change', () =>{
            for( var i = 0 ; i < ipCheckList.length ; i++){
                ipCheckList[i].checked = allCheck.checked;
            }
        });
        ipCheckList.forEach((chk) => {
            chk.addEventListener('click', () =>{
                let chkip = 0
                for( var i = 0 ; i < ipCheckList.length ; i++){
                    if(ipCheckList[i].checked){
                        chkip ++
                    }
                }
                if(chkip == ipCheckList.length){
                    allCheck.checked = true;
                }else{
                    allCheck.checked = false;
                }
            });
        })
        // ipChoiceCk.forEach((chk) => {
        //     chk.addEventListener('change', () =>{
        //         let ipChoiceCkLi = chk.closest('li');
        //         let ipChangeCk = ipChoiceCkLi.querySelector('.ip_choice');
        //         let ipChangeCkAll = ipChoiceCkLi.querySelectorAll('.ip_all[name=agree_chk]');

        //         for( var i = 0 ; i < ipChangeCkAll.length ; i++){
        //             ipChangeCkAll[i].checked = ipChangeCk.checked;
        //         }
        //     });
        // })

        // let toggleConBtn = document.querySelectorAll('.btn--toggle');
        // toggleConBtn.forEach((btn)=>{
        //     btn.addEventListener('click', function(event){
        //         let toggleLi = event.target.closest('li')
        //         let liClass = toggleLi.classList.contains('on');
        //         if(liClass == false){
        //             toggleLi.classList.add('on');
        //             event.target.closest('button').classList.add('active');
        //             event.target.innerHTML = "내용닫기"
        //         }else{
        //             toggleLi.classList.remove('on');
        //             event.target.closest('button').classList.remove('active');
        //             event.target.innerHTML = "내용보기"
        //         }
        //     })
        // })
    };
    // member - join - join-ok-page
    // if(document.querySelector('.join-ok-page')){
    //     let joinSelect = document.querySelectorAll('#join_ok_select');
    //     joinSelect.forEach((opt) => {
    //         opt.addEventListener('change', () => {
    //             let conId = opt.options[opt.selectedIndex].value
    //             let conIdTop = document.querySelector("#" + conId).offsetTop;

    //             window.scrollTo({top:conIdTop - 60, behavior: 'smooth'});
    //         })
    //     })
    // }
});
